var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-card-grid-description",class:_vm.cssClass},[(_vm.title !== undefined && _vm.title.length > 0)?_c('span',{staticClass:"product-card-grid-description-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "+_vm._s(_vm.description)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }